<template>
    <p v-if="!envARLDE">
        Nous sommes désolés, nous ne sommes pas en mesure de récupérer ces informations pour le moment. 
        Veuillez réessayer ultérieurement.
    </p>
    <p v-else-if="envARLDE">
        Leider sind wir derzeit nicht in der Lage, diese Informationen abzurufen. 
        Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
    </p>
</template>

<script>
export default {
    name: 'Error',
    props: {
        envARLDE: Boolean
    }
}
</script>